<template>
  <div class="Investment-box">
    <div class="head-text">
      <ul class="breadcrumbs-list">
        <a href="javascript:void(0)"   @click="backToFinStat"><li>FinStat</li></a>
        <li>&nbsp;>&nbsp;Category</li>
      </ul>
    </div>
    <div class="head-text">
      <h1>FinStat</h1>
    </div>
    <div class="card-box">
      <h4>Select your option</h4>
      <v-row>
        <template>
          <v-card
            v-for="categoryList in category"
            :key="categoryList.id"
            class="mx-auto"
            outlined
            @click="subcategory(categoryList.id, categoryList.type)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                  <v-img
                    max-height="39"
                    max-width="39"
                    :src="webIcon + categoryList.web_icon"
                  >
                  </v-img>
                </div>
                <v-list-item-title>{{ categoryList.type }}</v-list-item-title>
              </v-list-item-content>
              <v-btn
                @click="subcategory(categoryList.id, categoryList.type)"
                text
              >
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data: () => ({
    category: '',
    webIcon: process.env.VUE_APP_ROOT_ICONS_URL,
  }),
  mounted() {
    this.categoryData();
  },
  methods: {
     backToFinStat(){
        this.$router.push({ name: 'FinStat' }).catch(() => {});
     },
    subcategory(category_id, type) {
      if (type != '') {
        this.$router.push({
          name: 'FinStatArticles',
          params: { category: category_id, category_name: type, props: true },
        });
      }
    },
    categoryData() {
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata = new FormData();
      formdata.append('aws_cognito_id', cognito_idp);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'finstat-categories-listing',
          formdata,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.category = response.data.data;
        });
    },
  },
};
</script>
